import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import {MdMoreVert} from 'react-icons/lib/md'
import DropdownMenu from 'react-dd-menu'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

export default class Actions extends React.Component {
  static propTypes = {
    options: PropTypes.array
  }
  static defaultProps = {
    options: []
  }
  state = {
    isMenuOpen: false
  }

  @autobind
  toggle(e) {
    e.stopPropagation()
    this.setState({isMenuOpen: !this.state.isMenuOpen})
  }
  @autobind
  close() {
    this.setState({isMenuOpen: false})
  }

  click() {
    console.log('You clicked an item')
  }

  renderOptions() {
    return this.props.options.map((option, key) => {
      return (
        <li key={key} onClick={e => e.stopPropagation()}>
          {option}
        </li>
      )
    })
  }

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: <Button className={styles.button} onClick={this.toggle} label={<MdMoreVert />} />,
      align: 'left',
      menuAlign: 'left'
    }
    return (
      <DropdownMenu animate {...menuOptions}>
        {this.renderOptions()}
      </DropdownMenu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/Actions/index.js